import { debug } from '../utils/debug';

const isTopicsSupportAvailable = (): boolean => {
  return (
    'browsingTopics' in document &&
    (document as any).featurePolicy?.allowsFeature('browsing-topics')
  );
};

const getBrowsingTopics = async () => {
  const supported = isTopicsSupportAvailable();
  if (!supported) {
    return {
      topics: [],
      supported,
      error: false,
      message: null,
    };
  }

  try {
    const topics = await (document as any).browsingTopics();
    debug('Topics fetched:', topics);

    return {
      topics,
      supported,
      error: false,
      message: null,
    };
  } catch (err) {
    debug('Error fetching topics:', err);

    return {
      topics: [],
      supported,
      error: true,
      message: String(err),
    };
  }
};

export { getBrowsingTopics, isTopicsSupportAvailable };
